import PropTypes from 'prop-types';

import WineCriticSlide from '@/components/product/WineCriticSlide';
import CarouselSlides from '@/components/layout/carouselV3/CarouselSlides';
import CarouselContainer from '@/components/layout/carouselV3/CarouselContainer';
import { useScreenSizeContext } from '@/components/ScreenSize.context';

const CarouselWineCritics = ({ ratings }) => {
  const { isDesktop } = useScreenSizeContext();

  return ratings.length > 0 && (
    <CarouselContainer
      withGap={false}
      withFreeScrolling={!isDesktop}
      renderComponent={
        (props) => (
          <CarouselSlides {...props}>
            {ratings.map((rating, i) => (
              <WineCriticSlide key={i} rating={rating} />
            ))}
          </CarouselSlides>
        )}
    />
  );
};

CarouselWineCritics.propTypes = {
  ratings: PropTypes.array.isRequired
};

export default CarouselWineCritics;
